import React from "react";
import {
  useTable,
  useSortBy,
  useGlobalFilter,
  usePagination,
} from "react-table";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import { HiArrowsUpDown } from "react-icons/hi2";
import { Table, Container, Button, Form, Row, Col } from "react-bootstrap";
import "./Table.css";

const TableComponentPagepay = ({ columns, data }) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    state,
    // setGlobalFilter,
    canPreviousPage,
    canNextPage,
    // pageOptions,
    // gotoPage,
    nextPage,
    previousPage,
    setPageSize,
  } = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const { globalFilter, pageIndex, pageSize } = state;

  return (
    <Container className="mt-0 mb-0 pb-0">
      <Row className="justify-content-end align-items-center mb-2">
        <Col lg={3} md={4} sm={6}>
          <div className="d-flex align-items-center gap-2">
            <span style={{ fontSize: "14px", color: "#94a3b8" }}>Show</span>
            <select
              name="10"
              id=""
              style={{
                outline: "none", // Remove the outline
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)", // Add a slight shadow
                color: "#94a3b8",
                borderRadius: "3px", // Optional: adjust border radius
                fontSize: "16px", // Optional: adjust font size
              }}
            >
              <option value="hello">10</option>
            </select>

            <span style={{ fontSize: "14px", color: "#94a3b8" }}>Per Page</span>
          </div>
        </Col>
      </Row>
      <Table {...getTableProps()} striped bordered hover className="pb-0 mb-2">
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  className="text-center position-relative"
                  style={{
                    backgroundColor: "#292d2e",
                    color: "#f8f9fa",
                    fontSize: "12px",

                    overflow: "visible", // Ensures text isn't hidden
                    minWidth: "max-content", // Ensures th expands to fit content
                    padding: "10px", // Provides spacing around text
                    lineHeight: "normal", // Ensures proper line height
                    verticalAlign: "middle", // Vertically centers the text
                  }}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps()}>
                {row.cells.map((cell, i) => (
                  <td {...cell.getCellProps()} className="text-center">
                    {cell.render("Cell")}
                  </td>
                ))}
              </tr>
            );
          })}
        </tbody>
      </Table>
      {/* {data.length === 0 && <div className="alert  mt-0  bg-grey py-lg-2 text-secondary rounded-0  text-secondary" >Is Empty</div>} */}
      <div className="d-flex justify-content-start align-items-center mt-1">
        <div style={{ fontSize: "14px" }}>
          Showing 0 to 10 (0 total entries)
        </div>
        <div className="d-flex align-items-center ms-2">
          <button
            onClick={() => previousPage()}
            disabled={!canPreviousPage}
            className="me-2 px-2 py-1  border-1"
          >
            <FaAngleLeft size={18} className="text-secondary" />
          </button>
          {/* <div className=" px-3 py-1" style={{border:"1px solid yellow"}}>
  {pageIndex + 1}
</div> */}
          <button
            onClick={() => nextPage()}
            disabled={!canNextPage}
            className="ms-2 px-2 py-1  border-1"
          >
            <FaAngleRight size={18} className="text-secondary" />
          </button>
        </div>
      </div>
    </Container>
  );
};

export default TableComponentPagepay;
